import { render, staticRenderFns } from "./FactorCalendarSemester.vue?vue&type=template&id=a2180c1c&scoped=true"
import script from "./FactorCalendarSemester.vue?vue&type=script&lang=ts"
export * from "./FactorCalendarSemester.vue?vue&type=script&lang=ts"
import style0 from "./FactorCalendarSemester.vue?vue&type=style&index=0&id=a2180c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2180c1c",
  null
  
)

export default component.exports